import React from "react";
import { connect } from "react-redux";
import Select from 'react-select';

import "./EditEmployees.css"

import { SET_USERS_LIST } from "../../../../../actions/types";
import { getAllUnits, setOuName, getOuName, getOuEmployees, editOuEmployees } from "../../../../../actions/structureActions";

class EditEmployees extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            addOperations: {},
            updateOperations: {},
            deleteOperations: {}
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getAllUnits();
        if (this.props.match.params.ouID) this.props.getOuEmployees(null, SET_USERS_LIST)
        if (this.props.match.params.ouID) this.props.getOuName(this.props.match.params.ouID);
        else this.props.setOuName();
        this.props.getOuEmployees(this.props.match.params.ouID ? this.props.match.params.ouID : null);
    }

    onRowUpdate = (user, value) => {
        this.setState({ updateOperations: { ...this.state.updateOperations, [user.userID]: value.value !== null ? { ...user, destination: value } : null } });
    };

    onNewChange = (userID, value) => {
        if (userID !== null) this.setState({ addOperations: { ...this.state.addOperations, [userID]: null, [value.value.userID]: value.value } });
        else this.setState({ addOperations: { ...this.state.addOperations, [value.value.userID]: value.value } });
    }

    onRowDelete = (user) => {
        this.setState({ deleteOperations: { ...this.state.deleteOperations, [user.userID]: this.state.deleteOperations[user.userID] ? null : user } });
    };

    onNewDelete = (userID) => {
        this.setState({ addOperations: { ...this.state.addOperations, [userID]: null } });
    };

    onChangesApply = () => {
        const formValues = {
            addOperations: [...Object.keys(this.state.addOperations).map(key => this.state.addOperations[key] ? this.state.addOperations[key].userID : null).filter(v => v !== null)],
            updateOperations: [...Object.keys(this.state.updateOperations).map(key => (this.state.updateOperations[key] && !this.state.deleteOperations[key]) ? { userID: this.state.updateOperations[key].userID, ouID: this.state.updateOperations[key].destination.value.ouID } : null).filter(v => v !== null)],
            deleteOperations: [...Object.keys(this.state.deleteOperations).map(key => this.state.deleteOperations[key] ? this.state.deleteOperations[key].userID : null).filter(v => v !== null)]
        };
        this.props.editOuEmployees(this.props.match.params.ouID ? this.props.match.params.ouID : null, formValues, this.onChangeSuccess);
    };

    onChangeSuccess = () => this.setState(this.initialState);

    renderUnitsOptions = (prefix, units) => {
        let options = []
        units.forEach(unit => {
            options.push({ label: `${prefix} ${unit.symbol} | ${unit.name}`, value: unit });
            options = [
                ...options,
                ...this.renderUnitsOptions(`${prefix}_`, unit.subOUs)
            ]
        })
        return options
    };

    renderRows = () => this.props.employees.map(employee => {
        return (
            <div key={employee.userID} className={`ui ${this.state.deleteOperations[employee.userID] ? "secondary red " : this.state.updateOperations[employee.userID] ? "secondary yellow " : ""}segment`}>
                {this.renderRow(employee, false)}
            </div>
        );
    });

    renderNewRows = () => Object.keys(this.state.addOperations).map(key => {
        return (this.state.addOperations[key] ? (
            <div key={key} className="ui secondary green segment">
                {this.renderRow(this.state.addOperations[key], true)}
            </div>
        ) : <React.Fragment key={key} />);
    });

    renderRow = (employee, isNew) => {
        return (
            <div className={`ui ${employee ? "" : "header "}grid`}>
                {employee && isNew ? (
                    <div className="row">
                        <div className="four wide normal overflow column">
                            <Select
                                value={{ label: `${employee.lname} ${employee.fname}`, value: employee.userID }}
                                onChange={value => this.onNewChange(employee.userID, value)}
                                options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                                placeholder="Użytkownik"
                                noOptionsMessage={() => "Nie znaleziono użytkowników"}
                                maxMenuHeight="400px"
                            />
                        </div>
                    </div>
                ) : null}
                <div className="row">
                    <div className={`${this.props.match.params.ouID && !isNew ? "two" : "four"} wide column`}>
                        <div className="content">{employee ? employee.userID : "Numer ewidencyjny"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{employee ? `${employee.lname} ${employee.fname}` : "Nazwisko i imię"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{employee ? employee.email : "Email"}</div>
                    </div>
                    {!isNew ? (
                        <div className="four wide overflow column">
                            {employee ? (
                                <Select
                                    isDisabled={this.state.deleteOperations[employee.userID] !== null && this.state.deleteOperations[employee.userID] !== undefined}
                                    value={this.state.updateOperations[employee.userID] ? this.state.updateOperations[employee.userID].destination : { label: "< Bez zmian >", value: null }}
                                    onChange={value => this.onRowUpdate(employee, value)}
                                    options={[{ label: "< Bez zmian >", value: null }, ...this.renderUnitsOptions("", this.props.unitsList)]}
                                    placeholder="Jednostka organizacyjna"
                                    noOptionsMessage={() => "Nie znaleziono jednostki organizacyjnej"}
                                    maxMenuHeight="400px"
                                />
                            ) : "Przenieś do"}
                        </div>
                    ) : null}
                    {this.props.match.params.ouID || isNew ? (
                        <div className={`${isNew ? "four" : "two"} wide overflow column`}>
                            {employee ? (
                                <button className="ui button" onClick={() => isNew ? this.onNewDelete(employee.userID) : this.onRowDelete(employee)}>{isNew ? "Anuluj" : this.state.deleteOperations[employee.userID] ? "Cofnij" : "Usuń"}</button>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        )
    };

    renderChanges = () => {
        const changes = [
            ...Object.keys(this.state.addOperations).map(key => this.renderChange(this.state.addOperations[key], key, "add")),
            ...Object.keys(this.state.updateOperations).map(key => this.renderChange(this.state.updateOperations[key], key, "update")),
            ...Object.keys(this.state.deleteOperations).map(key => this.renderChange(this.state.deleteOperations[key], key, "delete"))
        ].filter(v => v !== null);

        return changes.length ? (
            <React.Fragment>
                <div className="ui divider" />
                <div className="ui secondary blue segment">
                    <div className="ui header">
                        <div className="content">Wykaz zmian</div>
                    </div>
                    {changes}
                </div>
                <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                <button className="ui button" onClick={() => this.setState(this.initialState)}>Anuluj</button>
            </React.Fragment>
        ) : null;
    };

    renderChange = (operation, key, type) => {
        return (operation && (type !== "update" || (type === "update" && !this.state.deleteOperations[key]))) ? (
            <div key={`${type}${operation.userID}`} className={`${type === "add" ? "green" : type === "update" ? "yellow" : "red"} content`}>
                {type === "add" ? "Dodano" : type === "update" ? "Przeniesiono" : "Usunięto"} użytkownika&nbsp;
                <b>{operation.lname} {operation.fname}</b>&nbsp;
                {type === "delete" ? "z" : "do"} jednostki&nbsp;
                <b>{type === "update" ? operation.destination.value.name : this.props.ouName}</b>
            </div>
        ) : null;
    };

    render() {
        return (
            <React.Fragment>
                <div className="edit-employees-component ui container">
                    <div className="ui container">
                        <div className="ui header">
                            <div className="content">{this.props.match.params.ouID ? `Pracownicy jednostki: ${this.props.ouName}` : "Pracownicy nieprzypisani"}</div>
                        </div>
                        <div className="ui divider" />
                        {this.props.employees.length ? (
                            <React.Fragment>
                                {this.renderRow()}
                                {this.renderRows()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="ui small header">
                                    <div className="content">{this.props.match.params.ouID ? "Brak pracowników jednostki" : "Brak nieprzypisanych praconików"}</div>
                                </div>
                                <div className="ui divider" />
                            </React.Fragment>
                        )}
                        {this.props.match.params.ouID ? (
                            <React.Fragment>
                                {Object.keys(this.state.addOperations).find(key => this.state.addOperations[key]) ? this.renderRow(null, true) : null}
                                {this.renderNewRows()}
                                <Select
                                    value={{ label: "Dodaj...", value: null }}
                                    onChange={value => this.onNewChange(null, value)}
                                    options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: u } })]}
                                    placeholder="Użytkownik"
                                    noOptionsMessage={() => "Nie znaleziono użytkowników"}
                                    maxMenuHeight="400px"
                                />
                            </React.Fragment>
                        ) : null}
                        {this.renderChanges()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    unitsList: state.structure.list,
    usersList: state.user.list,
    ouName: state.structure.edit.name,
    employees: state.structure.edit.employees
});

export default connect(mapStateToProps, { getAllUnits, setOuName, getOuName, getOuEmployees, editOuEmployees })(EditEmployees);